import { createFeatureActionNamer } from '../../../../../../../redux/action-name';

const getActionName = createFeatureActionNamer('post-underwriting-changes');

export const ADD_POST_UNDERWRITING_CHANGE = getActionName('ADD_POST_UNDERWRITING_CHANGE');
export const UPDATE_POST_UNDERWRITING_CHANGE = getActionName('UPDATE_POST_UNDERWRITING_CHANGE');
export const DELETE_POST_UNDERWRITING_CHANGE = getActionName('DELETE_POST_UNDERWRITING_CHANGE');
